/* eslint-disable @vp/swan/no-deprecated  -- we will need to update to AdaptiveCarousel */
/* eslint-disable @vp/swan/required-accessibility-props -- intentionally using deprecated props until i18n migration */
import React from 'react';

import Slider from 'react-slick';

import { Carousel } from '@vp/swan';
import type { CarouselProps } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';

import { stylesheet } from './ThumbnailsCarousel.scss';

export const ThumbnailsCarousel = React.forwardRef<Slider, CarouselProps>((props, ref) => {
  useStyles(stylesheet);
  return (
    <Carousel {...props} ref={ref} className={`thumbnails-carousel ${props.className || ''}`} />
  );
});
